<div class="cx-popover" [ngClass]="position">
  @if (arrow) {
    <div class="cx-popover-arrow"></div>
  }

  @if (isTemplate) {
    <ng-container [ngTemplateOutlet]="template" />
  }
  @else {
    <span [innerHTML]="content"></span>
  }
</div>
